__webpack_require__.p = "/insightboard-dashboard/";